import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* Row spacing is carried by each row's own padding; zeroing the
         shared gap keeps the padding tracks exact too. */
      --block-row-gap: 0px;
    }

    .boyle-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      align-items: normal;
    }

    img {
      max-width: 100%;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: var(--text-stack-header-gap);
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      padding-bottom: var(--text-stack-cta-gap);
    }

    .ctas-list {
      grid-column: 2 / 8;
      grid-row: 4;
      display: flex;
      flex-direction: column;
    }

    cta-button:not(:first-child) {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .boyle-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      /* Top-row texts share a first baseline. */
      .header {
        grid-column: 2 / 6;
        grid-row: 2;
        align-self: baseline;
      }

      .description {
        grid-column: 6 / 9;
        grid-row: 2;
        align-self: baseline;
      }

      /* The button stack joins the row on its first button's label
         baseline. */
      .ctas-list {
        grid-column: 10 / 13;
        grid-row: 2;
        align-self: baseline;
      }
    }
  `,
];
